import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button, Result } from 'antd'

function NotFound() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Result
      status="404"
      title="404"
      subTitle={t('notFound.desc')}
      extra={
        <Button type="primary" onClick={() => navigate('/apps')}>
          {t('notFound.back')}
        </Button>
      }
    />
  )
}

export default NotFound
